import type { SVGProps } from "react";

export function CryptoLine( props: SVGProps<SVGSVGElement> ) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <path
                d="M2.44434 9.5538L5.68522 6.31291C5.85856 6.13958 6.14034 6.13958 6.31367 6.31291L9.24078 9.24002C9.41411 9.41335 9.69589 9.41335 9.86922 9.24002L13.5546 5.55469"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.44434 2.44531V11.3342C2.44434 12.3164 3.23989 13.112 4.22211 13.112H13.5554"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
